"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotTypeSchema = exports.synonymsSchema = exports.LexValueSelectionStrategy = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const LexResourceNamePattern = /^([0-9a-zA-Z][_-]?)+$/;
var LexValueSelectionStrategy;
(function (LexValueSelectionStrategy) {
    LexValueSelectionStrategy["TOP_RESOLUTION"] = "TOP_RESOLUTION";
    LexValueSelectionStrategy["ORIGINAL_VALUE"] = "ORIGINAL_VALUE";
})(LexValueSelectionStrategy || (exports.LexValueSelectionStrategy = LexValueSelectionStrategy = {}));
exports.synonymsSchema = yup_lib_1.default.string().required();
const enumerationValuesSchema = yup_lib_1.default.object().shape({
    value: yup_lib_1.default.string().required(),
    synonyms: yup_lib_1.default.array().of(exports.synonymsSchema).optional()
});
exports.SlotTypeSchema = yup_lib_1.default.object().shape({
    name: yup_lib_1.default
        .string()
        .required()
        .matches(LexResourceNamePattern, 'Please enter intent slot name consisting Alphabet, Number, _ & -'),
    description: yup_lib_1.default.string().required(),
    valueSelectionStrategy: yup_lib_1.default
        .mixed()
        .oneOf(Object.values(LexValueSelectionStrategy))
        .required(),
    enumerationValues: yup_lib_1.default.array().of(enumerationValuesSchema).optional()
});
